import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Default extends Component {
  render() {
    return <div>Default Section Form</div>
  }
}

export default Default;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/templates/sections/default.js